import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import cacheManager from '../CacheManager';
import { formatDate } from '../js/dateFormatter';

const PgRelFinanceiro = () => {
  
  const [clientesByIdCache, setClientesByIdCache] = useState({});
  
  const [pagamentos, setPagamentos] = useState([]);

  // Função para obter o primeiro dia do mês anterior
  const getFirstDayOfPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setDate(1);
    return date.toISOString().split('T')[0];
  };

  // Função para obter o último dia do mês anterior
  const getLastDayOfPreviousMonth = () => {
    const date = new Date();
    date.setMonth(date.getMonth(), 0);
    return date.toISOString().split('T')[0];
  };

  const [dataInicial, setDataInicial] = useState(getFirstDayOfPreviousMonth());
  const [dataFinal, setDataFinal] = useState(getLastDayOfPreviousMonth());
  const [pagamentosFiltrados, setPagamentosFiltrados] = useState([]);
  const [pagamentosOrdenados, setPagamentosOrdenados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const search = useCallback(async () => {
    try {
      setIsLoading(true);

      const clientesByIdCache = await cacheManager.getClientesById()
      setClientesByIdCache(clientesByIdCache);
      
      const pagamentosCache = await cacheManager.getPagamentosCache();
      setPagamentos(pagamentosCache);

    } catch (error) {
      console.error('Erro ao buscar pagamentos:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Estilos para esmaecer a página
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2,
    display: isLoading ? 'block' : 'none',
  };

  useEffect(() => {
    search();
  }, [search, dataInicial, dataFinal]);

  useEffect(() => {
    const pagamentosFiltrados = pagamentos.filter(pagamento => {

      if (!pagamento.data_pagamento || isNaN(new Date(pagamento.data_pagamento).getTime())) {
        console.warn(`Pagamento inválido:`, pagamento);
        return false; // Exclui pagamentos inválidos
      }

      const dataPagamento = new Date(pagamento.data_pagamento).toISOString().split('T')[0];
      const dataInicialDate = dataInicial ? new Date(dataInicial).toISOString().split('T')[0] : null;
      const dataFinalDate = dataFinal ? new Date(dataFinal).toISOString().split('T')[0] : null;
      
      if (dataInicialDate && dataPagamento < dataInicialDate) {
        return false;
      }

      if (dataFinalDate && dataPagamento > dataFinalDate) {
        return false;
      }

      return true;
    });

    const pagamentosOrdenados = [...pagamentosFiltrados].sort((a, b) => {
      const aX = new Date(a.data_pagamento);
      const bX = new Date(b.data_pagamento);

      return bX - aX;
    });

  

  setPagamentosFiltrados(pagamentosFiltrados);
  setPagamentosOrdenados(pagamentosOrdenados);
  }, [pagamentos, dataInicial, dataFinal]);

  // Calcular total de registros e somatório do valor
  const totalRegistros = pagamentosFiltrados.length;
  const somatorioValor = pagamentosFiltrados.reduce((total, pagamento) => total + parseFloat(pagamento.valor), 0);

  // Formatar o somatório do valor
  const somatorioValorFormatado = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(somatorioValor);

  return (
    <div className="container mt-5">
      {isLoading && <div style={overlayStyle}></div>}
      <h2 className="mb-4">Financeiro</h2>
      <div className="input-group mb-3">
        <div className="form-group">
          <label htmlFor="data-inicial">Data Inicial</label>
          <input
            type="date"
            className="form-control"
            id="data-inicial"
            value={dataInicial}
            onChange={(e) => setDataInicial(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="data-final">Data Final</label>
          <input
            type="date"
            className="form-control"
            id="data-final"
            value={dataFinal}
            onChange={(e) => setDataFinal(e.target.value)}
          />
        </div>
      </div>
      <table className="table">
        <thead className="table-light">
          <tr>
            <th>Nº Fatura</th>
            <th>Nº Pag</th>
            <th>Cliente</th>
            <th>Data Pag.</th>
            <th>Data Ext.</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {pagamentosOrdenados.map((pagamento, index) => (
            <tr key={index} style={{ height: 'auto !important', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <td>
                <Link to={`/fatura/editar/${pagamento.id_fatura}`} className="text-dark underline-on-hover">
                  {pagamento.id_fatura}
                </Link>
              </td>
              <td>
                <Link to={`/pagamento/editar/${pagamento.id_pagamento}`} className="text-dark underline-on-hover">
                  {pagamento.id_pagamento}
                </Link>
              </td>
              <td>{clientesByIdCache[pagamento.id_cliente]?.nome || 'Cliente não encontrado'}</td>
              <td>{formatDate(pagamento.data_pagamento)}</td>
              <td>{formatDate(pagamento.data_extorno)}</td>
              <td>R$ {pagamento.valor}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-3">
        <p>Total de Registros: {totalRegistros}</p>
        <p>Total recebido: {somatorioValorFormatado}</p>
      </div>
    </div>
  );
};

export default PgRelFinanceiro;